const MOBILE_WEB_REGEX = /cotdmob|m.catch/;

export const getSourcePlatform = () =>
  MOBILE_WEB_REGEX.test(
    typeof window !== "undefined" ? window.location.host : ""
  )
    ? "MOBILE"
    : "DESKTOP";
